$(document).ready(function(){
  $('.hs-site-search').click(function() {
    $('.hs-site-search-header').toggleClass('search-hide');
    $('.site-overlay').toggleClass('active');
    $('.site-overlay').css("z-index", "9998");
    setTimeout(function(){
      $(".hs-search-input").focus();
    },50);
  });

  $('.hs-site-search-header .hs-site-search').click(function() {
    $('.site-overlay').css("z-index", "9999");
  });
  
  // $('.site-overlay').click(function() {
  //   $('.hs-site-search-header').addClass('search-hide');
  //   $('.site-overlay').toggleClass('active');
  //   $('.site-overlay').css("z-index", "9999");
  // });
});


document.addEventListener("DOMContentLoaded", function () {

  async function getCart() {
    return await fetch('/cart.js')
      .then(response => response.json());
  }


  document.addEventListener("click", async function (e) {

    const checkoutBtn = e.target.closest(
      'button[name="checkout"], input[name="checkout"], a[href="/checkout"]'
    );

    if (!checkoutBtn) return;

    const cart = await getCart();

    const onlyGift = cart.items.length > 0 &&
      cart.items.every(item =>
        item.properties &&
        item.properties._widget_id
      );


    if (onlyGift) {

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      console.log("Only gift product found. Removing gift...");

      // Remove all gift items
      await fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      // Redirect home after removing gift
      window.location.href = "/";

      return false;
    }

  }, true);

});